import { render, staticRenderFns } from "./ToBeUploaded.vue?vue&type=template&id=48920ff4&scoped=true&"
import script from "./ToBeUploaded.vue?vue&type=script&lang=js&"
export * from "./ToBeUploaded.vue?vue&type=script&lang=js&"
import style0 from "./ToBeUploaded.vue?vue&type=style&index=0&id=48920ff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48920ff4",
  null
  
)

export default component.exports